/*********************************************************
 *                  Admin users Ctrl
 *
 ********************************************************/

"use strict";

angular
	.module("exploitation")
	.controller("EitiDisruptionsCtrl", ["$scope",
		"Utils",
		"disruptions",
		"$uibModal",
		"$location",
		"$log",
		"EitiDisruptionsService",
		"toastr"
		,function(
		$scope,
		Utils,
		disruptions,
		$uibModal,
		$location,
		$log,
		EitiDisruptionsService,
		toastr
	) {
		/************************************************************************************************************
		 *  SETUP
		 *************************************************************************************************************/

		$scope.data = {
			disruptions: disruptions.data,
			endedDisruptions : [],
			currentDisruptions : []
		};




		/**
		 * Starting periods to filter disruptions
		 */
		$scope.data.startingPeriods = [
			{
				name: "Ce mois-ci",
				get: EitiDisruptionsService.getCurrentMonthDisruptions
			},
			{
				name: "Cette semaine",
				get: EitiDisruptionsService.getCurrentWeekDisruptions
			},
			{
				name: "Ces 30 derniers jours",
				get: EitiDisruptionsService.getLast30DaysDisruptions
			},
			{
				name: "Cette année",
				get: EitiDisruptionsService.getCurrentYearDisruptions
			}
		];


		var deleteModal;

		/************************************************************************************************************
		 *  $scope functions
		 *************************************************************************************************************/

		/**
		 * Opens disruption delete modal
		 */
		$scope.openDeleteModal = function(disruption) {
			$scope.data.entityToDelete = disruption;
			deleteModal = Utils.openModal($uibModal, "delete.html", $scope);
		};

		$scope.deleteEntity = function(disruption) {
			EitiDisruptionsService.deleteDisruption(disruption.id)
				.then(() => {
					toastr.success("", "Perturbation supprimée");
					EitiDisruptionsService.getAll().then((response) => {
						$scope.data.disruptions = response.data;
						filterDisruptions();
						deleteModal.close();
						$location.url("e-iti/perturbations");
					});
				})
				.catch((error) => {
					toastr.error(
						error.data.message,
						"Problème lors de la suppression de la perturbation"
					);
				});
		};

		/**
		 * Change the disruption diffusion status
		 * @param disruption
		 */
		$scope.diffuseEntity = function (disruption){
			EitiDisruptionsService.diffuse(disruption.id)
				.then(() => {
					toastr.success("", "Perturbation diffusée");
					EitiDisruptionsService.getAll().then((response) => {
						$scope.data.disruptions = response.data;
						filterDisruptions();
						$location.url("e-iti/perturbations");
					});
				})
				.catch((error) => {
					toastr.error(
						error.data.message,
						"Problème lors de la diffusion de la perturbation"
					);
				});
		};

		/**
		 * Filters disruptions by start date
		 */
		$scope.filterStartingFrom = function(startingPeriod) {
			const disruptionsSupplier = startingPeriod
				? startingPeriod.get
				: EitiDisruptionsService.getAll;
			disruptionsSupplier().then((response) =>{
				$scope.data.disruptions = response.data;
				filterDisruptions();
			});
		};

		$scope.getDisruptionStatus = function(disruption) {
			let currentDate = new Date();
			let endDate = new Date(disruption.endDateTime);

			if (disruption.endDateTime == null || endDate > currentDate){
				return "En cours";
			}

			return "Terminée";

		}

		$scope.getDisruptionColor = function(disruption) {
			let currentDate = new Date();
			let endDate = new Date(disruption.endDateTime);
			let color = '#FFCCB';
			if (endDate > currentDate){
				color = '#90EE90';
			}

			return { 'background-color' : color };
		};

		$scope.filterStartingFrom();

		/************************************************************************************************************
		 *  other functions
		 *************************************************************************************************************/

		function filterDisruptions() {

			if ($scope.data.disruptions == null || $scope.data.disruptions == undefined || $scope.data.disruptions === ""){
				$scope.data.currentDisruptions=[];
				return;
			}

			$scope.data.endedDisruptions = 	$scope.data.disruptions.filter(disruption => $scope.getDisruptionStatus(disruption) === "Terminée");

			$scope.data.currentDisruptions = 	$scope.data.disruptions.filter(disruption => $scope.getDisruptionStatus(disruption) === "En cours");

		}


	}]);
